import React, { Component } from "react";
import logo from './img/logo.png';
import './Login.css';
import { Link } from "react-router-dom";
import Alertmessage from '../src/components/common/alertMessage';
import Field from '../src/components/common/Field';
//import axios from 'axios';
import axios from '../src/util/axios';
import { trackPromise } from "react-promise-tracker";

class Login extends Component {

	state = {
		username: "",
		password: "",
		loginError: false,
		errorMessage: ""
	};	

	handleChange = event => {
		this.setState({
			[event.target.name] : event.target.value
		});
	};

	handleLogin = async event => {
		const data={};
		data.username = this.state.username;
		data.password = this.state.password;
		trackPromise(
			axios.post('/api/user/login', data, {
				headers: {}
			})
			.then(res => {
				localStorage.setItem('userData', JSON.stringify(res.data));
				localStorage.setItem('cobrandId', JSON.stringify(res.data.cobrands[0].id));
				this.setState({loginError: false});
				//this.props.history.push("/");
				window.location.href = "/"; 
			})
			.catch(err => {
				if (err.response.data && err.response.data.errorMessage) {
					this.setState({ errorMessage: err.response.data.errorMessage });
				}
				this.setState({ loginError: true });			
			})
		);
	};

	render() {
		return (
			<div className="wrapper login">
				<div id="formContent">
					<div className="fadeIn first">
						<img src={logo} alt="logo" />
					</div>
					{ this.state.loginError && 
						<Alertmessage message={this.state.errorMessage} alertType={'alert-danger'}/>
					}
					<input type="text" name="username" className="fadeIn second" placeholder="Email" value={this.state.username} onChange={this.handleChange} />
					<Field type="password" name="password" className="fadeIn third" iconClass="fas fa-eye fa-1x pointer fadeIn third" iconBottom="200px" iconLeft="375px" placeholder="Password" value={this.state.password} onChange={this.handleChange} />
					<input type="submit" className="fadeIn fourth" value="Login" onClick={this.handleLogin} />

					<div id="formFooter">
						<Link className="underlineHover" to={{ pathname: '/manageLogin', state: { view: 'reqotp'} }}>Forgot Password?</Link>
					</div>
				</div>
			</div>
		);
	}

};

export default Login;